import { useState, useEffect } from 'react';
import { endOfWeek, isSameMonth, startOfWeek } from 'date-fns';
import { addDays, addWeeks, addMonths, addYears } from 'date-fns/fp';
import { KeyCode } from './types';
import { not } from './utils';
const getNextDay = addDays(1);
const getPreviousDay = addDays(-1);
const getNextWeek = addWeeks(1);
const getPreviousWeek = addWeeks(-1);
const getFirstDayOfWeek = (focusedDay, weekStartsOn) => startOfWeek(focusedDay, { weekStartsOn });
const getLastDayOfWeek = (focusedDay, weekStartsOn) => endOfWeek(focusedDay, { weekStartsOn });
const getNextMonth = addMonths(1);
const getPreviousMonth = addMonths(-1);
const getNextYear = addYears(1);
const getPreviousYear = addYears(-1);
const isNotSameMonth = not(isSameMonth);
export function useFocusRoving({ initialFocusedDay, initOffset = 0, weekStartsOn = 0, }) {
    const [focusedDay, setFocusedDay] = useState(initialFocusedDay);
    const [stateOffset, setStateOffset] = useState(initOffset);
    useEffect(() => {
        setStateOffset(initOffset);
    }, [initOffset]);
    // useEffect(() => {
    //   setFocusedDay(initialFocusedDay);
    // }, [initialFocusedDay]);
    const moveFocusToNextDay = () => {
        const nextDay = getNextDay(focusedDay);
        if (isNotSameMonth(nextDay, focusedDay)) {
            setStateOffset(stateOffset + 1);
        }
        setFocusedDay(nextDay);
    };
    const moveFocusToPreviousDay = () => {
        const previousDay = getPreviousDay(focusedDay);
        if (isNotSameMonth(previousDay, focusedDay)) {
            setStateOffset(stateOffset - 1);
        }
        setFocusedDay(previousDay);
    };
    const moveFocusToNextWeek = () => {
        const nextWeek = getNextWeek(focusedDay);
        if (isNotSameMonth(nextWeek, focusedDay)) {
            setStateOffset(stateOffset + 1);
        }
        setFocusedDay(nextWeek);
    };
    const moveFocusToPreviousWeek = () => {
        const previousWeek = getPreviousWeek(focusedDay);
        if (isNotSameMonth(previousWeek, focusedDay)) {
            setStateOffset(stateOffset - 1);
        }
        setFocusedDay(previousWeek);
    };
    const moveFocusToFirstDayOnWeek = () => {
        const firstDayOfWeek = getFirstDayOfWeek(focusedDay, weekStartsOn);
        if (isNotSameMonth(firstDayOfWeek, focusedDay)) {
            setStateOffset(stateOffset - 1);
        }
        setFocusedDay(firstDayOfWeek);
    };
    const moveFocusToLastDayOfWeek = () => {
        const lastDayOffWeek = getLastDayOfWeek(focusedDay, weekStartsOn);
        if (isNotSameMonth(lastDayOffWeek, focusedDay)) {
            setStateOffset(stateOffset - 1);
        }
        setFocusedDay(lastDayOffWeek);
    };
    const moveFocusToNextMonth = () => {
        const nextMonth = getNextMonth(focusedDay);
        setStateOffset(stateOffset + 1);
        setFocusedDay(nextMonth);
    };
    const moveFocusToPreviousMonth = () => {
        const previousMonth = getPreviousMonth(focusedDay);
        setStateOffset(stateOffset - 1);
        setFocusedDay(previousMonth);
    };
    const moveFocusToNextYear = () => {
        const nextYear = getNextYear(focusedDay);
        setStateOffset(stateOffset + 12);
        setFocusedDay(nextYear);
    };
    const moveFocusToPreviousYear = () => {
        const previousYear = getPreviousYear(focusedDay);
        setStateOffset(stateOffset - 12);
        setFocusedDay(previousYear);
    };
    const handleKeyDown = (event) => {
        if (event.key === KeyCode.ArrowUp) {
            moveFocusToPreviousWeek();
        }
        if (event.key === KeyCode.ArrowRight) {
            moveFocusToNextDay();
        }
        if (event.key === KeyCode.ArrowDown) {
            moveFocusToNextWeek();
        }
        if (event.key === KeyCode.ArrowLeft) {
            moveFocusToPreviousDay();
        }
        if (event.key === KeyCode.HOME) {
            moveFocusToFirstDayOnWeek();
        }
        if (event.key === KeyCode.END) {
            moveFocusToLastDayOfWeek();
        }
        if (event.key === KeyCode.PAGEUP) {
            if (event.shiftKey) {
                moveFocusToPreviousYear();
            }
            else {
                moveFocusToPreviousMonth();
            }
        }
        if (event.key === KeyCode.PAGEDOWN) {
            if (event.shiftKey) {
                moveFocusToNextYear();
            }
            else {
                moveFocusToNextMonth();
            }
        }
    };
    return {
        focusedDay,
        stateOffset,
        setFocusedDay,
        handleKeyDown,
    };
}
